import { action, payload } from 'ts-action'

export const SetIsDisabledTimesheetHotkeys = action(
  'SetIsDisabledTimesheetHotkeys',
  payload<boolean>()
)
